import RemoteImage from '@/components/Image/RemoteImage/RemoteImage';
import {selectIsEmbedded} from '@/state/selectors/app';
import type {ImageModel} from '@/types/content';
import {useSelector} from 'react-redux';

type Props = {
    className?: string;
    imageMedia?: ImageModel[];
    pictureClassName?: string;
    imgClassName?: string;
};

const AemImage = ({className, imageMedia, pictureClassName, imgClassName}: Props) => {
    const isEmbedded = useSelector(selectIsEmbedded);
    // Tips embedded in the desktop app: AEM also sends mobile image variants.
    // Filter them out and keep only desktop ones (viewport.width > 0).
    const desktopImages = imageMedia?.filter((image) => (image.viewport?.width ?? 0) > 0);
    const resolvedImageMedia = isEmbedded && desktopImages?.length ? desktopImages : imageMedia;

    return (
        <div className={className}>
            <RemoteImage
                imageMedia={resolvedImageMedia}
                className={pictureClassName}
                imgClassName={imgClassName}
            />
        </div>
    );
};

export default AemImage;
